import * as angular from "angular";
import * as _ from "lodash";
import {apsCommands} from "../../shared/dto/aps.commands";

export interface ShiftScheduleValidationService {
  getValidationErrors(shiftSchedules: apsCommands.PlantCommandShiftSchedule[]): string[];
}

let minutesInDay = 24 * 60;

class ShiftScheduleValidationSvc implements ShiftScheduleValidationService {

  getValidationErrors(shiftSchedules: apsCommands.PlantCommandShiftSchedule[]): string[] {
    if (!shiftSchedules || !shiftSchedules.length) {
      return ['Shift schedule is required'];
    }

    let errors = [];

    let validateEntireDayCoverage = () => {
      let shiftIntervalSum = _.sum(_.map(shiftSchedules, (shift) => {
        let stop = (shift.startMinute >= shift.stopMinute) ? shift.stopMinute + minutesInDay : shift.stopMinute;
        return stop - shift.startMinute;
      }));

      if (shiftIntervalSum < minutesInDay) {
        errors.push('Shift schedule must cover the entire day');
      }
    };

    let validateShiftOverlaps = () => {
      let sortedShifts = _.sortBy(shiftSchedules, 'startMinute');
      let lastStop = _.last(sortedShifts).stopMinute;
      _.each(sortedShifts, function (shift) {
        if (shift.startMinute !== lastStop) {
          errors.push('Shift schedule must not overlap');
          return false;
        }
        lastStop = shift.stopMinute;
      });
    };

    validateEntireDayCoverage();
    if (0 === errors.length) {
      validateShiftOverlaps();
    }

    return errors;
  }

}

export default angular
  .module('aps.services.shiftschedulevalidation', [])
  .service('shiftScheduleValidationService', ShiftScheduleValidationSvc)
  .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/services/utility/shiftschedulevalidation.service.ts